import React from "react";
import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import SimpleResponsivePicture from "./SimpleResponsivePicture";
import StrapiGrid from "./StrapiGrid";

import BioModal from "./BioModal";
export default function Headshots(props) {
  return (
    <StrapiGrid options={props?.options.layout}>
      {props?.TeamMember &&
        props?.TeamMember?.map((member, index) => {
          return (
            <Grid item key={member.id}>
              <PersonWrapper container direction={"column"} className="person">
                <SimpleResponsivePicture
                  imageObj={member?.graphic?.data?.attributes}
                  sx={{ height: "auto", width: { xs: "calc(100svw - 4rem)", sm: 270, md: 242 } }}
                />

                <Grid item align="left" dangerouslySetInnerHTML={{ __html: member?.copy }} />
                <BioModal {...member} trigger={props.trigger} theme={props.theme} />
              </PersonWrapper>
            </Grid>
          );
        })}
    </StrapiGrid>
  );
}

const PersonWrapper = styled(Grid)`
  & > div > h4 {
    margin: 1rem 0 0.25rem;
  }
  & > div > p {
    margin: 0 0 1rem;
  }
`;
